import React, { useEffect } from 'react'
import pocketmoney from '../../Images/pocketmoney.png'
import money from '../../Images/money.png'
import camel from '../../Images/camel.png'
import arrow from '../../Images/arrow.png'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useMatch, useNavigate } from 'react-router-dom'

function ZakaCalcTaps({ activeComponent, setActiveComponent }) {
    const navigate = useNavigate();
    const isHomePage = useMatch('/zaka-calculator');
    const handleCheckRoute = (route) => {
        if (isHomePage !== null) {
            setActiveComponent(route)
        } else {
            navigate('/zaka-calculator')
        }
    };


    useEffect(() => {
        if (isHomePage !== null) {
            const element = document.getElementById('zakCalc');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }

    }, [])


    return (
        <>
            <div id='zakCalc' className={isHomePage === null ? 'container max-w-7xl mx-auto' : ''}>
                <div className="mb-10 p-5 mt-12 w-full bg-white rounded-2xl border border-solid border-zinc-300 border-opacity-80 max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                        {isHomePage === null &&
                            <div className="flex flex-col items-center justify-center w-3/12 max-md:ml-0 max-md:w-full rounded-lg text-3xl font-bold text-center  text-zinc-900">
                                حساب
                                <br />
                                الزكــــــاة
                            </div>
                        }


                        <button className={`flex flex-col w-3/12 max-md:ml-0 max-md:mt-10 max-md:w-full rounded-lg ${activeComponent === 'Stock' ? 'bg-amber-300 border-solid border-b-[5px] border-b-yellow-600 text-stone-900'
                            : `${isHomePage !== null ? 'bg-blue-50 border border-blue-50 border-solid text-stone-900' : 'bg-[#fed37024] border border-[#FFCD50] border-solid text-stone-900'}`}`}
                            onClick={() => handleCheckRoute('Stock')}>
                            <div className="flex flex-col grow justify-center self-stretch px-4 py-5 w-full text-base font-bold text-center whitespace-nowrap">
                                <LazyLoadImage
                                    loading="lazy"
                                    src={pocketmoney}
                                    className="self-center aspect-[0.97] w-[87px]"
                                />
                                <div className="mt-4">زكاة الأسهم</div>
                            </div>
                        </button>
                        <button className={`flex flex-col w-3/12 max-md:ml-0 max-md:mt-10 max-md:w-full rounded-lg ${activeComponent === 'Anam' ? 'bg-amber-300 border-solid border-b-[5px] border-b-yellow-600 text-stone-900'
                            : `${isHomePage !== null ? 'bg-blue-50 border border-blue-50 border-solid text-stone-900' : 'bg-[#fed37024] border border-[#FFCD50] border-solid text-stone-900'}`}`}
                            onClick={() => handleCheckRoute('Anam')}>
                            <div className="flex flex-col grow justify-center self-stretch px-4 py-5 w-full text-base font-bold text-center whitespace-nowrap">
                                <LazyLoadImage
                                    loading="lazy"
                                    src={money}
                                    className="self-center aspect-[0.99] w-[85px]"
                                />
                                <div className="mt-5">زكاة الأنعام</div>
                            </div>
                        </button>
                        <button className={`flex flex-col w-3/12 max-md:ml-0 max-md:mt-10 max-md:w-full rounded-lg ${activeComponent === 'Gold' ? 'bg-amber-300 border-solid border-b-[5px] border-b-yellow-600 text-stone-900'
                            : `${isHomePage !== null ? 'bg-blue-50 border border-blue-50 border-solid text-stone-900' : 'bg-[#fed37024] border border-[#FFCD50] border-solid text-stone-900'}`}`}
                            onClick={() => handleCheckRoute('Gold')}>
                            <div className="flex flex-col grow justify-center self-stretch px-4 py-5 w-full text-base font-bold text-center whitespace-nowrap">
                                <LazyLoadImage
                                    loading="lazy"
                                    src={camel}
                                    className="self-center aspect-[0.99] w-[89px]"
                                />
                                <div className="mt-4">زكاة الذهب</div>
                            </div>
                        </button>
                        <button className={`flex flex-col w-3/12 max-md:ml-0 max-md:mt-10 max-md:w-full rounded-lg ${activeComponent === 'Money' ? 'bg-amber-300 border-solid border-b-[5px] border-b-yellow-600 text-stone-900'
                            : `${isHomePage !== null ? 'bg-blue-50 border border-blue-50 border-solid text-stone-900' : 'bg-[#fed37024] border border-[#FFCD50] border-solid text-stone-900'}`}`}
                            onClick={() => handleCheckRoute('Money')}>
                            <div className="flex flex-col grow justify-center self-stretch px-4 py-5 w-full text-base font-bold text-center whitespace-nowrap">
                                <LazyLoadImage
                                    loading="lazy"
                                    src={arrow}
                                    className="self-center aspect-[0.99] w-[89px]"
                                />
                                <div className="mt-4">زكاة المال</div>
                            </div>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ZakaCalcTaps